import { SimulatedPaymentOption } from '@common/apis/simulated-debt/types';
import { legacyBase64Encrypt, legacyBase64Decrypt } from '@libs/utils/helpers/base64';
import constants from '@common/constants';

// [TEMP]:  to adapt to the legacy project
export const getFromLS = (key: string) => {
  const encryptedData = localStorage.getItem(key);
  const returnMyDebts = () => (window.location.href = '/minhas-dividas');

  const isPaymentDate = key === 'PAYMENT_DATE';
  if (!encryptedData && isPaymentDate) return null;

  if (!encryptedData) {
    returnMyDebts();
    return null;
  }

  try {
    const decryptedData = JSON.parse(legacyBase64Decrypt(encryptedData));

    if (key === constants.debts.DEBT) {
      if (!decryptedData?.timestamp) {
        returnMyDebts();
        return null;
      }

      const now = new Date().getTime();
      const diffInMinutes = (now - decryptedData.timestamp) / 1000 / 60;

      if (diffInMinutes > 30) {
        returnMyDebts();
        return null;
      }

      return decryptedData.value;
    }

    return decryptedData;
  } catch (error) {
    returnMyDebts();
    return null;
  }
};

export const setInLS = (key: string, value: { [key: string]: string | number | any }) => {
  let data = value;

  if (key === constants.debts.DEBT) {
    data = {
      timestamp: new Date().getTime(),
      value,
    };
  }

  const encryptedValue = legacyBase64Encrypt(JSON.stringify(data));

  return localStorage.setItem(key, encryptedValue);
};

export function findBestOffer(paymentOptions: SimulatedPaymentOption[] = [], algorithm: 'v3a' | 'v3b' | 'v3c') {
  const safePaymentOptions = paymentOptions || [];
  return safePaymentOptions.find((option) => !!option?.best_offer_variants?.[algorithm]);
}

export const pushUrl = () => {
  const currentUrl = window.location.pathname + window.location.search;
  window.history.pushState(null, '', `${currentUrl}`);
};
